import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          "hello": "Hello app!!",
          "click_me": "Click me",
          "logout": "Logout",
          "login": "Login",
          "AtHome": "Home Service",
          "register": "Register",
          "documents": "Documents",
          "authorities": "Authorities",
          "welcome": "Hello {{name}}",
        }
      },
      ar: {
        translation: {
          "hello": "مرحبا بالتطبيق!!",
          "click_me": "اضغط هنا",
          "Logout": "تسجيل الخروج",
          "login": "تسجيل الدخول",
          "register": "تسجيل",
          "documents": "المستندات",
          "Documents": "المستندات",
          "letters": "المعاملات",
          "Letters": "المعاملات",
          "authorities": "الجهات",
          "welcome": "مرحبا {{name}}",
          "language": "لغة",
          "Page Size": "حجم الصفحة",
          "Reset": "مسح الفلاتر",
          "Search": "بحث",
          "Search...": "بحث...",
          "Add new document": "إضافة مستند",
          "Actions": "عمليات",
          "Update By": "عدل بواسطة",
          "Last Update": "اخر تعديل",
          "AI Result": "المحتوى",
          "Brief": "نبذة",
          "Apply Filter": "فلتر",
          "Filters": "الفلاتر",
          "From Date": "من تاريخ",
          "To Date": "الى تاريخ",
          "Users List": "قائمة المستخدمين",
          "Search an user": "البحث عن مستخدم",
          "Download PDF Report": "تقرير عدد الوثائق لكل مستخدم",
          "Name": "الاسم",
          "Cancel": "الغاء",
          "Create Authority": "اضافة جهة",
          "Create": "اضافة",
          "Add New Authority": "اضافة جهة جديدة",
          "Confirm Delete": "تأكيد الحذف",
          "Confirm": "تأكيد",
          "Are you sure you want to delete this": "هل متأكد أنك تريد حذف هذه",
          "Authority Name": "اسم الجهة",
          "authority": "الجهة",
          "Authorities": "الجهات",
          "document": "الرسالة",
          "?": "؟",
          "Email": "البريد الإلكتروني",
          "Address": "العنوان",
          "Phone": "الهاتف",
          "Emirates Id": "الهوية الإماراتية",
          "External Authority": "الجهة الخارجية",
          "Search an authority": "ابحث عن جهة",
          "Generate": "إنشاء",
          "Generate ChatGPT Result": "إنشاء نتيجة ChatGPT",
          "Back": "رجوع",
          "Save": "حفظ",
          "Result": "النتيجة",
          "All": "كل",
          "Home": "الرئيسية",
          "Main Menu": "القائمة الرئيسية",
          "Reports": "التقارير",
          "Delete": "حذف",
          "Edit": "تعديل",
          "View": "عرض",
          "Aboutus": "معلومات عنا",
          "Booking Services": "خدمات الحجز",
          "Dashboards": "لوحة التحكم",
          "Contact": "تواصل",
          "MEDICAL DHA": "الخدمات الطبية - هيئة الصحة بدبي",
          "Typing Services": "خدمات الطباعة",
          "Amer Services": "خدمات آمر",
          "DET Services": "خدمات دائرة الاقتصاد والسياحة",
          "Golden Visa Services": "خدمات التأشيرة الذهبية",
          "Why Karama Business Center?": "لماذا مركز الكرامة للأعمال؟",
          "One Stop Transactions": "معاملات متكاملة في مكان واحد",
          "The Karama Business Center in Dubai offers a comprehensive range of government services, ensuring convenience and efficiency for residents and businesses.": "يقدم مركز الكرامة للأعمال في دبي مجموعة شاملة من الخدمات الحكومية، مما يضمن الراحة والكفاءة للمقيمين والشركات.",
          "Premium Fast Track Service": "خدمة متميزة وسريعة",
          "The Karama Business Center in Dubai offers a Premium Fast Track Service to expedite various government-related processes, ensuring efficiency and convenience for clients.": "يوفر مركز الكرامة للأعمال في دبي خدمة متميزة وسريعة لتسريع مختلف العمليات الحكومية، مما يضمن الكفاءة والراحة للعملاء.",
          "Dedicated Assistance": "مساعدة مخصصة",
          "Personalized support throughout the application process.": "دعم شخصي طوال عملية التقديم.",
          "Experienced Staff:": "طاقم عمل ذو خبرة:",
          "A team of knowledgeable professionals is available to assist clients, providing guidance and support throughout various processes": "فريق من المحترفين ذوي المعرفة متاح لمساعدة العملاء، وتقديم التوجيه والدعم خلال مختلف العمليات.",
          "Happy Customers": "عملاء سعداء",
          "16,000K": "16,000 ألف",
          "Count of Centers": "عدد المراكز",
          "2+": "2+",
          "625K+": "625 ألف+",
          "200K+": "200 ألف+",
          "Trusting Companies": "شركات موثوقة",
          "Strategic Partners": "شركاء استراتيجيون",
          "View all News": "عرض جميع الأخبار",
          "View More": "عرض المزيد",
          "About Company": "عن الشركة",
          "Our Company": "شركتنا",
          "Services": "الخدمات",
          "Letter List": "المعاملات",
          "Faq": "الأسئلة الشائعة",
          "Category List": "الفئات",
          "Service List": "الخدمات",
          "Car List": "السيارات",
          "Notification List": "الإشعارات",
          "WorkingTime List": "أوقات العمل",
          "Authority List": "الجهات",
          "Booking List": "الحجوزات",
          "All Services": "كل الخدمات",
          "Privacy Policy": "سياسة الخصوصية",
          "Quick links": "روابط سريعة",
          "Contact Info": "معلومات التواصل",
          "© 2024 Karama Business Center. All Rights Reserved.": "© 2024 مركز الكرامة للأعمال. جميع الحقوق محفوظة.",
          "Frequently Asked Questions": "الأسئلة الشائعة",
          "2024 - Best Employee of the Month": "2024 - أفضل موظف لهذا الشهر",
          "2024 - DED Opening": "2024 - افتتاح دائرة التنمية الاقتصادية",
          "2023 - National Day Celeberation": "2023 - احتفال اليوم الوطني",
          "Karama Medical Fitness Center Medical Timing": "مواعيد مركز الكرامة لفحص اللياقة الطبية",
          "Monday - Thursday 7:00 AM -10:00 PM": "الإثنين - الخميس 7:00 صباحاً - 10:00 مساءً",
          "Friday 7:00 AM - 08:00 PM": "الجمعة 7:00 صباحاً - 8:00 مساءً",
          "Saturday - Sunday 8:00 AM - 08:00 PM": "السبت - الأحد 8:00 صباحاً - 8:00 مساءً",
          "How to check visa medical report online?": "كيف يمكن التحقق من تقرير الفحص الطبي للتأشيرة عبر الإنترنت؟",
          "Dubai visa medical report can be tracked and downloaded from DHA mobile application.": "يمكن تتبع وتنزيل تقرير الفحص الطبي للتأشيرة في دبي من تطبيق هيئة الصحة بدبي.",
          "Latest News": "آخر الأخبار",
          "Golden visa is one of the services provided by the Federal Authority for Identity": "التأشيرة الذهبية هي واحدة من الخدمات التي تقدمها الهيئة الاتحادية للهوية",
          "Simplify Your Entry Process with Our Amer Services": "بسط عملية الدخول الخاصة بك مع خدمات آمر",
          "Center ensures a smooth conduit for individuals and businesses to engage with DET": "يضمن المركز قناة سلسة للأفراد والشركات للتواصل مع دائرة الاقتصاد والسياحة",
          "Our Typing services are designed to simplify the documentation process": "تم تصميم خدمات الطباعة لدينا لتبسيط عملية التوثيق",
          "Medical Fitness Services and Occupational Health Screening Services for Visa": "خدمات اللياقة الطبية وخدمات الفحص الصحي المهني للتأشيرات",
          "We Karama Business Center offers many services to small and medium businesses with the highest standards of quality and speed for any transactions of all Government departments in Dubai": "نحن مركز الكرامة للأعمال نقدم العديد من الخدمات للشركات الصغيرة والمتوسطة بأعلى معايير الجودة والسرعة لأي معاملات لجميع الدوائر الحكومية في دبي.",
          "Facts By The Numbers": "الارقام تقول",
          "Enter You Email Here": "ادخل البريد الالكتروني",
          "Attestation Services": "خدمات التصديق",
          "Our Services": "خدماتنا",
          "Next to Karama Post Office,Dubai": "دبي، الكرامة، بحانب مكتب البريد",
          "AED": "درهم",
          "Please select a location on the map.": "الرجاء اختيار مكان على الخريطة",
          "AtHome": "الخدمة عندك (نأتيك للبيت)",
          "Pick & Drop": "الخدمة عندنا في المركز",
          "Pickup Date": "اختر تاريخ",
          "Select a time": "اختر وقت",
          "Book Now": "احجز الان",
          "Book Service": "حجز خدمة",
          "Total Cost": "التكلفة الاجمالية",
          "Customer Name": "اسم المستخدم",
          "Available slots": "اوقات الحجز المتاحة",
          "Book": "حجز",
          "Message to owner": "رسالة لمدير النظام",
          "Location": "الموقع",
          "Share": "مشاركة",
          "Chat Via Whatsapp": "تواصل عبر الواتس اب",
          "Phone Number": "رقم الهاتف",
          "Emirates Secretarial Services": "مكتب الامارات للخدمات الحكومية",
          "Owner Details": "معلومات لمدير النظام",
          "ABOUT OUR COMPANY":"",
          "One Stop Government Transactions":"",
          "In line with Dubais strategy for providing quality government services in one place and as quickly as possible, Al Karama Business Center has been one of the largest centers in Dubai to prove this idea since its inception. It provides a range of government and business services for the various business sectors using the latest intelligent systems. Because our clients’ time has an invaluable value and because the success of the individual depends on how it is invested for its time, we have developed the quality and speed of service delivery to facilitate customer’s access to it.Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.":"",
          "How It Works":"",

        }
      }
    },
    lng: "en", // اللغة الافتراضية
    fallbackLng: "en", // اللغة الاحتياطية
    interpolation: {
      escapeValue: false, // لا حاجة للهروب في React
    },
  });

export default i18n;
